const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_json`);

// 接口文档地址：
// http://219.128.52.2:18765/doc.html#/haolv-consumer/payment-controller/paymentChannelUsingPOST
const consumer_payment_getPayChannel = (pParameter) => {
    if (!pParameter) pParameter = {};
    const companyId = pParameter.companyId || ``;
    // const isUseCredit = to_boolean(pParameter.isUseCredit, true);
    const payAmount = pParameter.payAmount || 0;
    const type = pParameter.type || 1;//获取类型：1.支付，2.授信还款，3.胤钱宝充值
    const channelType = pParameter.channelType || 1;//渠道类型：1.pc，2.app

    const p = {
        method: 'post',
        urlSuffix: '/consumer/payment/getPayChannel',
        data: {
            companyId,
            // isUseCredit,
            payAmount,
            type,
            channelType,
        },
    };
    return Q.when()
        .then(function () {
            return __request(p);
        })
        .then(function (data) {
            return Q.resolve(data);
        })
        .catch(function (ex) {
            console.error(ex);
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;
};
module.exports = consumer_payment_getPayChannel;
